module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACxSURBVEhL7ZVdCoAgEIR76KA9drTu1F3cdmw2zCX6UQmiAdFV5ps0yk5EBm19V1lggo2BhBBmFJjk+mOBARaZEgNMJUHwwGtg0xaQL5QoZaU7iE+wDosUT2AdJgHcqauvijbPYf+BAH0xk7aR5eMAMMBiuXvJO9F3WbQ5HSffFG3+JNj7s7sp2jyH/R/wB5yLthcDVG1/1/r1Nb9wbKH+lVkCzgUGWBaEiSrgXGCKyLAACMIMydvWhtAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-open-window/light/24.png
// module id = 2288
// module chunks = 2